var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"app-container"},[_c('el-container',[_c('el-aside',[_c('app-aside',{attrs:{"data":_vm.menuList}})],1),_c('el-main',[_c('el-header',[_c('app-header')],1),_c('app-main')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }